import { useState, useEffect } from "react";

import { getSearchDateRange, SearchDateResponse } from "api/searchDate";

/**
 * 指定の日付をもとに締日の対象期間を取得する（年次帳票用）
 */
export const useSearchDateRange = (fromDate: string, toDate: string) => {
  const [searchDate, setSearchDate] = useState<SearchDateResponse>({
    id: "",
    fromDate: "",
    toDate: ""
  });
  useEffect(() => {
    getSearchDateRange({ fromDate, toDate }).then(res => {
      setSearchDate(res);
    });
  }, [fromDate, toDate]);
  return searchDate;
};

export default useSearchDateRange;
